import { ShowButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'

const MailTextEditActions = () => {

  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar>
      <ShowButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/mailServiceConfig/1`)
      }}/>
    </TopToolbar>
  )
}

export default MailTextEditActions